import { render, staticRenderFns } from "./testA.vue?vue&type=template&id=4ef77716&scoped=true&"
import script from "./testA.vue?vue&type=script&lang=js&"
export * from "./testA.vue?vue&type=script&lang=js&"
import style0 from "./testA.vue?vue&type=style&index=0&id=4ef77716&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef77716",
  null
  
)

export default component.exports